export const differentKeywordArray = [
  {
    icon: "/genwave/subpage/keyword/1.svg",
    keyPhrase: "이미지",
    description: "키워드 기반의 스타일 이미지 생성",
  },
  {
    icon: "/genwave/subpage/keyword/2.svg",
    keyPhrase: "영상",
    description: "장면별 시나리오 기반 자동 영상 생성",
  },
  {
    icon: "/genwave/subpage/keyword/3.svg",
    keyPhrase: "캐릭터",
    description: "AI로 생성된 캐릭터 디자인 (2D/3D 등)",
  },
  {
    icon: "/genwave/subpage/keyword/4.svg",
    keyPhrase: "BGM",
    description: "분위기에 맞는 배경 음악 생성",
  },
  {
    icon: "/genwave/subpage/keyword/5.svg",
    keyPhrase: "노래",
    description: "가사 기반 보컬 음악 또는 AI 커버 제작",
  },
  {
    icon: "/genwave/subpage/keyword/6.svg",
    keyPhrase: "숏폼",
    description: "짧은 영상 구도, 구성, 편집까지 자동 설계",
  },
];
